<template>
  <div class="box">
    <h3 class="title is-4">Blanket VOB Search</h3>
    <div class="content">
      <p>
        Get access to run a VOB across 100's of payers instantly without knowing the insurance
        company or having a Member ID. Find existing, secondary, or additional payers with one
        inquiry.
      </p>

      <h4>Benefits:</h4>
      <ul>
        <li>Search across hundreds of payers simultaneously</li>
        <li>No insurance company or Member ID required</li>
        <li>Find primary, secondary, and additional payers</li>
        <li>Streamlined verification process</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlanketVOBFeatureDetail',
};
</script>

<style scoped>
.content h4 {
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
  font-weight: 600;
}

.content ul {
  margin-top: 0.5rem;
}

.content li {
  margin-bottom: 0.5rem;
}
</style>
